<template>
  <div class="sample-psi"
       :id="samplePsiId">
    <svg></svg>
  </div>
</template>

<script>
import * as d3 from 'd3';
import tippy, { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
export default {
  name: 'SamplePsi',
  data() {
    return {
      sample_psi: [],
      project_id: null,
    }
  },
  props: {
    samplePsi: {
      type: Array,
      default() {
        return []
      }
    },
    projectId: {
      type: String,
      default() {
        return
      }
    },
    samplePsiId: {
      type: String,
      default() {
        return
      }
    }
  },
  watch: {
    projectId(val) {
      // console.log(val);
      this.project_id = val;
    },
    samplePsi(val) {
      if (val.length > 0) {
        // console.log(val);
        this.sample_psi = val;
        this.initSamplePsiPlot(this.sample_psi)
      }
    },
  },
  methods: {
    initSamplePsiPlot(sample_psi) {

      //   console.log(sample_psi);
      const samples = [];
      sample_psi && sample_psi.forEach((v, i, a) => {
        samples.push(v.sample_id);
      })
      const sample_size = samples.length;

      const margin = ({ top: 0, left: 200, right: 100, bottom: 0, });
      // const width = 1000;
      const width = sample_size * 8 + margin.left + margin.right;
      const height = 40;
      const gridWidth = 6;
      const gridHeight = 20;
      const sampleColor = "#BDBDBD";

      // Here, must replace this.project_id as project_id !!!
      let project_id = this.project_id;

      let psi_id = this.samplePsiId;
      // console.log(psi_id);
      // console.log(d3.selectAll("div.sample-psi"));
      const svg = d3.selectAll("div.sample-psi")
        .filter(function () {
          return d3.select(this).attr('id') == psi_id;
        })
        .select('svg')
      // .attr("viewBox", [0, 0, width, height]);
      svg.attr("width", width);
      svg.attr("height", height);
      // console.log(svg);

      // Clip Off Zoom Overflow
      // svg.append('clipPath')
      //   .attr('id', 'clipRect')
      //   .append('rect')
      //   .attr('x', margin.left - 1)
      //   .attr('y', margin.top)
      //   .attr('width', width - margin.left - margin.right + 1)
      //   .attr('height', height)

      let myColor = d3
        .scaleSequential()
        .domain([0, 1])
        .interpolator(t => d3.interpolateBlues(t))

      // for legend
      // const linearGradient = svg.append('defs')
      //   .append('linearGradient')
      //   .attr('x1', '0%')
      //   .attr('y1', '0%')
      //   .attr('x2', '0%')
      //   .attr('y2', '100%')
      //   .attr('id', 'linear-gradient');
      // linearGradient
      //   .selectAll('stop')
      //   .data([0, 1])
      //   .enter()
      //   .append('stop')
      //   .attr('offset', (d, i) => i / 1)
      //   .attr('stop-color', d => myColor(d));

      // Add xAxis
      let xScale = d3.scaleBand()
        .domain(samples)
        .range([margin.left, width - margin.right])
        .padding(1);

      // Add yAxis
      let yScale = d3.scaleBand()
        .domain([project_id])
        .range([margin.top, height])
      let yAxis = d3.axisLeft(yScale)
      svg.append("g")
        .attr("class", "y-axis")
        .attr("transform", `translate(${margin.left},${gridHeight / 2 - 8})`)
        .call(yAxis)
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll('.tick line').remove())
        .call(g => g.selectAll('.tick text').attr("font-size", "13")
          .attr("font-family", "Arial").attr("font-weight", "bold"))

      // Add Samples
      svg.append('g')
        .attr("class", "samples-psi")
        .selectAll()
        .data(sample_psi)
        .join("rect")
        .attr('x', d => xScale(d.sample_id))
        .attr('y', yScale(project_id) + gridHeight / 2)
        .attr('width', gridWidth)
        .attr('height', gridHeight)
        // .attr('rx', 0.5) // set border-radius
        .attr('stroke-width', 0.5) // set border width
        .attr('fill', function (d) {
          if (d.psi_value) {
            return myColor(d.psi_value)
          } else {
            return sampleColor
          }
        });
      let samples_psi_rects = d3.selectAll('.samples-psi rect');
      samples_psi_rects.attr('data-tippy-content', (d, i) => {
        return `<div>Sample ID: ${d.sample_id}</div>
            <div>Sample Type: ${d.sample_type}</div>
            <div>PSI Value: ${d.psi_value || "NA"}</div></div>`;
      });
      tippy(samples_psi_rects.nodes(), {
        allowHTML: true,
        placement: 'left',
        interactive: true,
        interactiveDebounce: 0,
        appendTo: () => document.body,
        // followCursor: 'horizontal',
        // plugins: [followCursor],
        maxWidth: 300,
        delay: 0,
        duration: [0, 0],
      });

      // Add legend colorBar
      // const legendHeight = height / 2;
      // svg.append('rect')
      //   .attr('width', 10)
      //   .attr('height', legendHeight)
      //   .attr(
      //     'transform',
      //     `translate(${width - margin.right + 10}, ${legendHeight - 2})`
      //   )
      //   .style('fill', 'url(#linear-gradient)');
      // Add Legend title
      // svg.append('text')
      //   .text('PSI Value')
      //   .attr(
      //     'transform',
      //     `translate(${width - margin.right + 16}, ${margin.top})`
      //   )
      //   .attr('text-anchor', 'middle')
      //   .attr('font-size', 6)
      //   .attr('font-weight', 'bold');
      // Add Legend min value
      // svg.append('text')
      //   .text('0.00')
      //   .attr(
      //     'transform',
      //     `translate(${width - margin.right + 22}, ${margin.top + 5})`
      //   )
      //   .attr('font-size', 5)
      // Add Legend max value
      // svg.append('text')
      //   .text('1.00')
      //   .attr(
      //     'transform',
      //     `translate(${width - margin.right + 22}, ${margin.top + 4 + legendHeight})`
      //   )
      //   .attr('font-size', 5)
    },
  },
}
</script>
<style scoped>
</style>